<template>
    <Popover v-slot="{ open }">
        <PopoverButton
            :class="[
                open ? 'text-nutreance-brown-darkest' : 'text-nutreance-brown',
                'group bg-navbar-brown rounded-md inline-flex items-center text-base font-medium hover:text-nutreance-brown-darkest focus:outline-none',
            ]"
        >
            <span>{{ product.name }}</span>
            <ChevronDownIcon
                :class="[
                    open
                        ? 'text-nutreance-brown-darkest'
                        : 'text-nutreance-brown',
                    'ml-2 h-5 w-5 group-hover:text-nutreance-brown-darkest',
                ]"
                aria-hidden="true"
            />
        </PopoverButton>

        <transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="opacity-0 -translate-y-1"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 -translate-y-1"
        >
            <PopoverPanel
                class="hidden md:block absolute z-20 top-full inset-x-0 transform shadow-lg bg-white border-b border-gray-200"
            >
                <div
                    class="max-w-7xl mx-auto grid gap-y-6 px-4 py-6 sm:grid-cols-2 sm:gap-8 sm:px-6 lg:grid-cols-4 lg:px-8"
                >
                    <a
                        v-for="item in productPages"
                        :key="item.id"
                        :href="item.href"
                        class="-m-3 p-3 flex flex-col justify-between rounded-lg hover:bg-gray-50"
                    >
                        <div class="flex items-center md:h-full lg:flex-col">
                            <div class="shrink-0">
                                <span
                                    :class="[
                                        productColor,
                                        'inline-flex items-center justify-center h-10 w-10 rounded-md text-white sm:h-16 sm:w-16',
                                    ]"
                                >
                                    <svg-vue
                                        class="h-7 w-7 sm:h-12 sm:w-12"
                                        :icon="item.svg"
                                        :key="item.id"
                                        aria-hidden="true"
                                    />
                                </span>
                            </div>

                            <div
                                class="ml-4 md:flex-1 md:flex md:flex-col md:justify-between lg:ml-0 lg:mt-4"
                            >
                                <div>
                                    <p
                                        class="text-base font-medium text-gray-900"
                                    >
                                        {{ item.name }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="bg-gray-50 border-t border-gray-200">
                    <div
                        class="max-w-7xl mx-auto space-y-6 px-4 py-5 sm:justify-center sm:flex sm:space-y-0 sm:space-x-10 sm:px-6 lg:px-8"
                    >
                        <div class="flow-root">
                            <a
                                :href="`/products/${product.slug}`"
                                class="px-24 py-3 flex items-center rounded-md text-base font-medium text-white bg-nutreance-green hover:bg-nutreance-green-darker"
                            >
                                <ShoppingCartIcon
                                    class="shrink-0 h-6 w-6 mr-2"
                                    aria-hidden="true"
                                />
                                <span>Order Now</span>
                            </a>
                        </div>
                    </div>
                </div>
            </PopoverPanel>
        </transition>
    </Popover>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { ChevronDownIcon, ShoppingCartIcon } from "@heroicons/vue/solid";

const props = defineProps<{
    product?: any;
    productPages?: any;
}>();

const productColor = computed(() => `bg-${props.product.slug}`);
</script>
